import styled from 'styled-components';

import { Heading } from '@dreryk/react-components';

export const StyledForColumnsSpan = styled.div`
   grid-column: 1 / span 4;
`;

StyledForColumnsSpan.displayName = 'StyledTwoColumnsSpan';

export const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 18px;
`;

StyledForm.displayName = 'StyledForm';

export const StyledHeading = styled(Heading)`
   color: ${(props) => props.theme.textBody};
`;

StyledHeading.displayName = 'StyledHeading';
